import { useContext } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { MODAL_BASIC_ALERT_DIALOG } from '../constants';
import { ModalContext } from '../../../contexts/ModalContext';

function BasicAlertDialog() {
  const modalContext = useContext(ModalContext);

  const modalProps = modalContext.openModalProps[MODAL_BASIC_ALERT_DIALOG];
  const modalOpen = modalContext.isModalOpen(MODAL_BASIC_ALERT_DIALOG);

  const closeModal = () => {
    modalContext.closeModal(MODAL_BASIC_ALERT_DIALOG);
  };

  if (!modalProps) {
    return null;
  }

  return (
    <div>
      <Dialog
        open={modalOpen}
        disableEnforceFocus={true}
        aria-labelledby="basic-alert-dialog-title"
      >
        <DialogTitle id="basic-alert-dialog-title">
          {modalProps.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{modalProps.modalWarning}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModal} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default BasicAlertDialog;
